import { useTheme } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import AppConstants from '../app-constants.ts';

export default function Layout() {
  const theme = useTheme();

  return (
    <Main theme={theme}>
      <Outlet />
    </Main>
  );
}

// min-height from FF Web is 800px, but they center everything on the page
const Main = styled.main`
  min-height: 350px;
  background-color: white;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  height: 100%;
  flex: 1;

  padding: ${({ theme }) => theme.spacing(2, 2)};

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: ${({ theme }) => theme.spacing(4)};
  }
  @media (min-width: ${AppConstants.MAX_WIDTH_WITH_PADDING}px) {
    justify-self: center;
    width: ${AppConstants.MAX_WIDTH}px;
  }
`;
